import React from 'react';
import { QRCodeCanvas } from 'qrcode.react';

const GiftCardPreview = ({ createdGiftCard, displayClientName, giftCardRef, handleDownload }) => {
  const totalServicios =
    createdGiftCard.servicios?.reduce((sum, s) => sum + Number(s.valor), 0) || 0;

    // Formateo de fecha DD/MM/YYYY
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };

  // Capitalizar primera letra de nombres
  const capitalizeFirstLetter = (str) => {
    return str
      .split(' ')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  };

  return (
    <div className="mt-10">
      <h3 className="text-2xl font-bold text-center text-pink-700 mb-6">Vista Previa de la Gift Card</h3>
      <div className="flex justify-center">
        <div
          ref={giftCardRef}
          className="w-[350px] h-[760px] bg-gradient-to-b from-pink-100 via-pink-50 to-white shadow-2xl p-6 flex flex-col items-center justify-between border-4 border-pink-300"
        >
          {/* Header */}
          <div className="text-center">
            <h1 className="text-4xl font-extrabold text-pink-800">Gift Card</h1>
            <p className="text-lg text-pink-700 font-semibold mt-1">Narella Nail Art</p>
            
          </div>

          {/* Amount */}
          <div className="bg-white/70 backdrop-blur-sm rounded-xl px-6 py-3 shadow-md mt-4">
            <p className="text-pink-900 font-bold text-2xl tracking-wide">
              Valor: ${totalServicios}
            </p>
          </div>

          {/* Client Info */}
          <div className="text-center mt-4 space-y-1">
            <p className="text-pink-900 font-medium">
              <span className="font-bold">De:</span> {capitalizeFirstLetter(displayClientName())}
            </p>
            <p className="text-pink-900 font-medium">
              <span className="font-bold">Para:</span> {capitalizeFirstLetter(createdGiftCard.destinatario_nombre)}
            </p>
          </div>

          {/* Services */}
          {createdGiftCard.servicios?.length > 0 && (
            <div className="bg-white/70 backdrop-blur-sm rounded-xl px-4 py-4 mt-4 shadow-md w-full">
              <h4 className="text-pink-800 font-semibold text-lg mb-2 text-center">Servicios Incluidos</h4>
              <ul className="space-y-2">
                {createdGiftCard.servicios.map((servicio) => (
                  <li key={servicio.servicio_id} className="flex justify-between text-pink-700 text-sm">
                    <span>{servicio.nombre}</span>
                    <span>${servicio.valor}</span>
                  </li>
                ))}
              </ul>
              
            </div>
          )}

          {/* QR Code */}
          <div className="mt-4 border border-pink-300 p-4 rounded-xl bg-white/70 backdrop-blur-sm shadow-inner flex flex-col items-center">
            {(() => {
              const baseUrl = 'https://narella.nistal.net/gifts/cards/data';
              const detailUrl = `${baseUrl}/${createdGiftCard.public_code}`;
              return (
                <>
                  <QRCodeCanvas
                    value={detailUrl}
                    size={140}
                    bgColor="#ffffff"
                    fgColor="#d63384"
                    level="H"
                    includeMargin={true}
                  />
                  <p className="text-xs text-pink-600 mt-2">Escanea para ver detalles</p>
                </>
              );
            })()}
          </div>

          {/* Footer Info */}
          <div className="text-center mt-4 space-y-1">
            <p className="text-pink-800 font-semibold text-sm">
              Código: {createdGiftCard.public_code}
            </p>
            {createdGiftCard.expires_at && (
              <p><span className="font-bold">Válido hasta:</span> {formatDate(createdGiftCard.expires_at)}</p>
            )}
            <p className="text-pink-600 text-xs italic max-w-[80%] mx-auto mt-1">
              “Válida para un solo uso. ¡Gracias por elegirnos!”
            </p>
          </div>
        </div>
      </div>

      {/* Download Button */}
      <div className="flex justify-center mt-6">
        <button
          onClick={handleDownload}
          className="bg-gradient-to-r from-pink-500 to-pink-600 hover:from-pink-600 hover:to-pink-700 text-white font-bold py-3 px-6 rounded-lg shadow-md hover:shadow-lg transition duration-300"
        >
          Descargar Gift Card
        </button>
      </div>
    </div>
  );
};

export default GiftCardPreview;
